import { Button } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'
import { CapstoneShield } from '../CapstoneShield'
import { scrollToContactForm } from '../scrollToContactForm'
import { PricingItem } from './PricingItem'
import styles from './PricingCard.module.scss'

/**
 * The third, full-width tier: the blurb and CTA sit beside the benefit list
 * rather than above it, so the card stays shallow next to the two seat tiers.
 */
export const CertificatesCard = ({
  onCtaClick,
}: {
  onCtaClick?: () => void
}) => {
  const { t } = useTranslation('@mc/next')

  const features = [
    t('forBusiness.pricingTiers.certificates.feature1'),
    t('forBusiness.pricingTiers.certificates.feature2'),
    t('forBusiness.pricingTiers.certificates.feature3'),
    t('forBusiness.pricingTiers.certificates.feature4'),
  ]

  return (
    <div className='mc-w-100 mc-corners--md mc-p-8 mc-bg-neutral-900 mc-mt-4 mc-mt-lg-8'>
      <div className='row'>
        <div className='col-12 col-lg-6'>
          <div className='d-flex align-items-center mc-gap-4 mc-mb-4'>
            <div
              className={`d-flex align-items-center justify-content-center flex-shrink-0 ${styles.iconContainer}`}
            >
              <CapstoneShield />
            </div>
            <div>
              <h3 className='mc-mb-1 mc-text-white mc-font-title mc-text--bold'>
                {t('forBusiness.pricingTiers.certificates.title')}
              </h3>
              <p className='mc-text-small mc-text-color--tint'>
                {t('forBusiness.pricingTiers.certificates.subtitle')}
              </p>
            </div>
          </div>
          <p className='mc-text-color--medium mc-mt-6 mc-mb-8'>
            {t('forBusiness.pricingTiers.certificates.description')}
          </p>
          <Button
            className='mc-corners--sm'
            onClick={() => {
              onCtaClick?.()
              scrollToContactForm()
            }}
          >
            {t('forBusiness.pricingTiers.certificates.button')}
          </Button>
        </div>
        <div className='col-12 col-lg-6 mc-mt-8 mc-mt-lg-0'>
          <ul>
            {features.map((feature, index) => (
              <li className='mc-mb-4' key={index}>
                <PricingItem>{feature}</PricingItem>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  )
}
